module.exports = __webpack_public_path__ + "img/orbico.4a2c4524.png";